import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { FEATURE_FLAG_NAME } from "common/constants";
import {
  PublicUserContext,
  PublicUserContextType,
} from "../Authentication/PublicUserContext";
import { AuthContext } from "../Authorization/AuthContext";
import { Button } from "../Common/Button";
import { PublicUserProfilePlaceholder } from "./__styles__/Layout";
import { PublicUserProfileCircleButton } from "./__styles__/Layout";
import { getPublicUserInitials } from "./utils";

type HeaderProfileProps = {
  inMenu?: boolean;
  onClickSignIn: () => void;
};

export const HeaderProfile = ({
  inMenu = false,
  onClickSignIn,
}: HeaderProfileProps) => {
  const { isFeatureEnabled } = useContext(AuthContext);
  const { currentPublicUser, currentPublicUserLoading } =
    useContext(PublicUserContext);

  if (!isFeatureEnabled(FEATURE_FLAG_NAME.PUBLIC_USERS)) return null;

  if (currentPublicUserLoading) return <PublicUserLoading inMenu={inMenu} />;
  if (currentPublicUser)
    return (
      <PublicUserProfile
        inMenu={inMenu}
        currentPublicUser={currentPublicUser}
      />
    );
  return <SignInButton onClick={onClickSignIn} inMenu={inMenu} />;
};

const PublicUserLoading = ({ inMenu = false }: { inMenu?: boolean }) => {
  if (inMenu) {
    return null;
  }
  return (
    <PublicUserProfilePlaceholder data-testid="public-user-profile-placeholder" />
  );
};

const PublicUserProfile = ({
  inMenu = false,
  currentPublicUser,
}: {
  inMenu?: boolean;
  currentPublicUser: NonNullable<PublicUserContextType["currentPublicUser"]>;
}) => {
  if (inMenu) {
    return null;
  }
  return (
    <PublicUserProfileCircleButton data-testid="public-user-profile-button">
      {getPublicUserInitials(currentPublicUser)}
    </PublicUserProfileCircleButton>
  );
};

const SignInButton = ({
  inMenu = false,
  onClick,
}: {
  inMenu?: boolean;
  onClick: () => void;
}) => {
  const { t } = useTranslation();

  const style = inMenu
    ? undefined
    : { minWidth: "unset", whiteSpace: "nowrap" as const };

  return (
    <Button
      onClick={onClick}
      styleVariant={inMenu ? "buttonLinkDark" : "secondary"}
      size={inMenu ? "medium" : "small"}
      style={style}
    >
      {t("sign-in")}
    </Button>
  );
};
